import { NumberField } from "react-admin";

export const MoneyField = ({ source, label, textAlign, emptyText }) => (
  <NumberField
    source={source}
    options={{ style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2 }}
    label={label}
    textAlign={textAlign}
    emptyText={emptyText}
  />
);
